<template>
  <time class="countdown-text" :datetime="datetime">{{ text }}</time>
</template>

<script setup lang="ts">
/**
 * 绝对时刻倒计时（只在客户端运行；服务端与挂载前显示占位）。
 * 每一跳按「目标 − serverNow()」重算，切回前台立即重算；到点 emit('expire')，
 * 由调用方**重新拉接口**，不要在本地直接改状态。
 */
import { formatInstant } from '~/utils/time'

const props = withDefaults(
  defineProps<{
    /** 目标时刻串（接口原值） */
    target?: string | null
    placeholder?: string
  }>(),
  { target: null, placeholder: '--:--:--' },
)

const emit = defineEmits<{ expire: [] }>()

const { countdown } = useTimeDisplay()
const { remaining, targetMs } = useCountdown(() => props.target, {
  onExpire: () => emit('expire'),
})

const datetime = computed(() =>
  targetMs.value === null ? undefined : formatInstant(targetMs.value),
)
const text = computed(() =>
  remaining.value === null ? props.placeholder : countdown(remaining.value),
)
</script>

<style scoped>
.countdown-text {
  font-variant-numeric: tabular-nums;
}
</style>
